<p>permission-flow-dialog works!</p>
